export default __webpack_public_path__ + "static/media/bubble_primary.eab61d9b.svg";